import React from "react";

import { StatementDetail } from "components/Statements/StatementDetail";

const StatementDetailPage = () => {
  return <StatementDetail />;
};
export default StatementDetailPage;
